import { Garantie } from "../../../services/Api/swagger";

export const buildGarantiesAssistance = (garanties: Garantie[]) => {
  const assistance = garanties.filter((g) => g.type === "Assistance");
  return assistance;
};

export const buildGarantiesAssurance = (garanties: Garantie[]) => {
  const assurance = garanties.filter((g) => g.type === "Remboursement");
  return assurance;
};

export const buildGarantiesInformations = (garanties: Garantie[]) => {
  const information = garanties.filter(
    (g) => g.type === "Information générale"
  );
  return information;
};
